<div neoDialogTitleContainer class="title-container">
  <cm-icon name="shield" color="danger" size="xs" aria-hidden="true" />
  <h2 neoDialogTitle>Access Denied</h2>
</div>

<div neoDialogContent class="dialog-content">
  <p class="message">You don't have permission to access this page.</p>
  <p class="message">Contact your administrator if you think this is a mistake.</p>
</div>

<div neoDialogActions class="dialog-actions">
  <cm-button variant="flat" color="primary" size="sm" (click)="onGoHome()" autId="access-denied-go-home-btn">
    Continue
  </cm-button>
</div>
